import { useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { sendEventToAppWrapper } from '@/utils/app-wrapper-utils';
import { selectAppReviewTag, selectUserId } from '@/store/selectors/userSelectors';
import { CustomWebToAppEvents } from '@/models/enum/app-wrapper.enum';

export function useSuccessfulExperience(): void {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const hasAppReviewTag = useSelector(selectAppReviewTag);
  const userId = useSelector(selectUserId);
  const sentRef = useRef(false);
  useEffect(() => {
    if (sentRef.current || !isAuthenticated || !userId || !hasAppReviewTag) {
      return;
    }
    sendEventToAppWrapper(CustomWebToAppEvents.app_review, {
      userId,
    });
    sentRef.current = true;
  }, [isAuthenticated, userId, hasAppReviewTag]);
}
